import React, { useEffect, useState, useRef } from "react";
import clsx from "clsx";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Input from "@mui/material/Input";
import { useStyles } from "./promptStyles";
import logo_svg from "../../assets/images/hublot-logo-underline.svg";
import close_svg from "../../assets/images/close.svg";
import { constants } from "../../constants";
import { EPromptState, IPrompt } from "./IPrompt";
import StateDivider from "./StateDivider/StateDivider";

import {
    aniClosePrompt,
    aniOpenPrompt,
    aniCompletePrompt,
    aniResponseText,
} from "./PromptAnimations";
import { getDataStatus } from "./utils";

const Prompt = ({
    data,
    promptUIState,
    setPromptUIState,
    handleSubmitPrompt,
}: IPrompt) => {
    const root = useRef<HTMLInputElement>(null);
    const { classes } = useStyles();
    const dataStatus = getDataStatus(data);

    const [inputValue, changeInputValue] = useState("");
    const [promptState, setPromptState] = useState<EPromptState>(
        EPromptState.Collapsed
    );

    /**
     * EFFECT HANDLERS
     * ------------------------------------------------------------
     */

    useEffect(() => {
        if (
            (dataStatus === "ready" || dataStatus === "complete") &&
            promptUIState === "open"
        ) {
            setPromptUIState("scrollable");
            setPromptState(EPromptState.Success);
            aniCompletePrompt();
        }
    }, [dataStatus, promptUIState, setPromptUIState]);

    useEffect(() => {
        if(data?.response_msg !== undefined){
            aniResponseText()
        }
    }, [data?.response_msg])
    

    /**
     * EVENT HANDLERS
     * ------------------------------------------------------------
     */

    const onSelectInputForm = () => {
        if (promptUIState === "closed") {
            setPromptUIState("open");
            aniOpenPrompt();
        }
    };

    const onCloseHandler = () => {
        setPromptUIState("closed");
        aniClosePrompt();
    };

    const handleOnKeyDown = (
        e: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>
    ) => {
        if (e.key === "Enter") {
            setPromptState(EPromptState.Thinking);
            e.preventDefault();
            handleSubmitPrompt(e.currentTarget.value);
            console.log("PROMPT handleOnKeyDown ANIMATION HERE -- 'ANIMATE");
        }
    };

    const wrapperHeight = promptUIState !== "scrollable" ? 124 : "auto";

    console.log("RENDER PROMPT ---------------", dataStatus, promptUIState);
    return (
        <Box id="prompt-wrapper" height={wrapperHeight}>
            <Box
                data-name="Prompt"
                ref={root}
                id="prompt-container"
                className={clsx([classes.root])}
            >
                <div id="red-wrap" className={clsx([classes.redwrap])} />
                <div className={clsx([classes.logo])}>
                    <img src={logo_svg} alt="Hublot logo" className="logo" />
                </div>
                <div className={clsx([classes.close])}>
                    <Button onClick={onCloseHandler}>
                        <img src={close_svg} alt="Close prompt" />
                    </Button>
                </div>
                <div className={clsx([classes.grid])}>
                    <Box
                        className={clsx([classes.inputContainer])}
                        id="prompt-input"
                    >
                        <Box id="prompt-caption" className="caption">
                            {constants.copy.prompt.caption_1}
                        </Box>
                        <Box className="input-box">
                            <form>
                                <Input
                                    id="font-size"
                                    placeholder={
                                        constants.copy.prompt.inputPlaceholder
                                    }
                                    disableUnderline={true}
                                    onChange={(e) => {
                                        changeInputValue(e.target.value);
                                    }}
                                    onClick={onSelectInputForm}
                                    onKeyDown={handleOnKeyDown}
                                    value={inputValue}
                                    autoComplete="off"
                                />
                            </form>
                            <StateDivider promptState={promptState} />
                            <Box
                                id="response"
                                className={clsx([classes.summary])}
                            >
                                {data?.response_msg}
                            </Box>
                        </Box>
                    </Box>
                </div>
            </Box>
        </Box>
    );
};

export default Prompt;
